"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionHeadingComponent = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

function SectionHeadingComponent(_ref) {
  var centered = _ref.centered,
      half = _ref.half,
      inverted = _ref.inverted,
      heading = _ref.heading,
      text = _ref.text,
      sloganText = _ref.sloganText,
      sloganOutlined = _ref.sloganOutlined,
      isDarkMode = _ref.isDarkMode,
      className = _ref.className;
  return react_1.default.createElement("div", {
    className: " flex  flex-wrap ".concat(centered ? 'flex-col justify-center items-center' : '', " ").concat(inverted ? 'text-white bg-black' : '', " ").concat(half ? 'flex-col justify-center items-center md-1:items-start' : 'items-center', " ").concat(isDarkMode ? 'text-white' : '', " ").concat(className === null || className === void 0 ? void 0 : className.mainWrapper)
  }, react_1.default.createElement("div", {
    className: "  ".concat(centered ? 'flex flex-col items-center' : half ? 'w-full flex flex-col md-1:block' : 'flex flex-col md-1:block md-1:pr-48 w-full md-1:w-1/2', "\n            ").concat(className === null || className === void 0 ? void 0 : className.wrapper, "\n            ")
  }, react_1.default.createElement("div", {
    className: "text-base flex md-1:text-sm leading-7 ".concat(centered ? 'flex-col justify-center items-center' : '', " text-gray-500 ").concat(sloganOutlined ? 'outlined' : '', " ").concat(className === null || className === void 0 ? void 0 : className.slogan)
  }, react_1.default.createElement("span", null, sloganText)), react_1.default.createElement("h2", {
    className: "font-30px text-left font-extrabold leading-7 ".concat(className === null || className === void 0 ? void 0 : className.heading)
  }, heading !== null && heading !== void 0 ? heading : 'Section Heading')), text && react_1.default.createElement("div", {
    className: " max-w-lg ".concat(inverted ? 'text-white' : 'text-gray-700', "\n            ").concat(half ? 'w-full' : 'w-full md-1:w-1/2', " ").concat(className === null || className === void 0 ? void 0 : className.textWrapper)
  }, react_1.default.createElement("p", {
    className: "text-sm ".concat(centered ? 'text-center' : 'md-1:text-left', " ").concat(className === null || className === void 0 ? void 0 : className.text)
  }, text !== null && text !== void 0 ? text : 'Lorem ipsum text')));
}

exports.SectionHeadingComponent = SectionHeadingComponent;
;
SectionHeadingComponent.propTypes = {
  centered: prop_types_1.default.bool,
  half: prop_types_1.default.bool,
  inverted: prop_types_1.default.bool,
  heading: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
  text: prop_types_1.default.string,
  sloganText: prop_types_1.default.string,
  sloganOutlined: prop_types_1.default.bool,
  isDarkMode: prop_types_1.default.bool,
  className: prop_types_1.default.object
};
SectionHeadingComponent.defaultProps = {
  centered: false,
  half: false,
  inverted: false,
  isDarkMode: false,
  sloganOutlined: false,
  className: {
    mainWrapper: "",
    wrapper: "",
    slogan: "",
    heading: "",
    textWrapper: "",
    text: ""
  }
};